/**
	*	stores the results of a WDFetch in a proxy and allows for direct updating
	* with the remote uri
	*
	*	@class WDApiObject
	*/

import WDFetchObject from './wd-fetch-object';

class WPFetchObject extends WDFetchObject {

	constructor(cfg,values)
	{
		const restURL = WPRestSettings.url;

		//remove the trailing slash from the rest url before setting
		//add the WP Nonce header also		
		const baseCfg = { baseURL: restURL.substr(0,restURL.length-1),
											headers: { 'X-WP-Nonce': WPRestSettings.nonce }
										};
								
		if (cfg) 
		{
			//passed a uri, set it up as the baseURI for the query
			if (typeof(cfg) == 'string') baseCfg.baseURI = cfg;
			else Object.assign(baseCfg,cfg);
		}

		super(baseCfg,values);
  };

};

export default WPFetchObject;
